module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "game"
  }, [_vm._v("\n    Game"), _c('br'), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": "/"
    }
  }, [_vm._v("Go back home")]), _vm._v(" (or use the browser button)"), _c('br'), _c('br')], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-526a94a3!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Game.vue
// module id = 117
// module chunks = 1